var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBannerMessage)?_c('div',{class:`banner ${_vm.bannerType}`},[_c('span',[_vm._v("\n    "+_vm._s(_vm.bannerMessage)+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }